// @flow
/** @jsx isolateComponent */

import { useState } from 'react';

import { StaticImage } from '@zapier/common-components';
import { Border, Colors } from '@zapier/theme';
import { isolateComponent, labelStyles } from '@zapier/common-utils';

type Props = {
  /** Logo alt text */
  name: string,
  /** Logo size */
  size: number,
  /** Url to logo image */
  url: ?string,
};

const DEFAULT_LOGO_URL = '/images/account-default-image.svg';

const Styles = labelStyles(__filename, {
  root: {
    alignItems: 'center',
    borderRadius: Border.radius.default,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  name: {
    color: Colors.white,
    display: 'block',
    fontSize: 15,
    fontWeight: 600,
    letterSpacing: '0.05em',
    marginTop: '1em',
    textTransform: 'uppercase',
  },
});

const TeamLogo = ({ name, size, url }: Props) => {
  // Used to fall back to default team image
  const [hasError, setHasError] = useState(false);

  // If it has errored out or we don't have a url then
  // fallback to default image
  const src = hasError || !url ? DEFAULT_LOGO_URL : url;

  return (
    <div css={Styles.root}>
      <StaticImage
        alt={`${name} logo`}
        height={size}
        onError={() => setHasError(true)}
        src={src}
        width={size}
      />
    </div>
  );
};

TeamLogo.defaultProps = {
  size: 128,
  url: DEFAULT_LOGO_URL,
};

export default TeamLogo;
